import { datadogLogs } from '@datadog/browser-logs';

const clearContact = (contact: connect.Contact): void => {
  contact.clear({
    success: function () {},
    failure: function (error) {
      datadogLogs.logger.error(`Failed to clear the contact: ${error}`);
    }
  });
};

export const endConversation = (contact: connect.Contact): void => {
  if (contact.isConnected()) {
    contact.getAgentConnection().destroy({
      success: function () {},
      failure: function (error) {
        datadogLogs.logger.error(`Failed to close the conversation: ${error}`);
      }
    });
  } else {
    clearContact(contact);
  }
};

export const endAndCloseConversation = (contact: connect.Contact, onError?: () => void): void => {
  contact.getAgentConnection().destroy({
    success: function () {
      clearContact(contact);
    },
    failure: function (error) {
      datadogLogs.logger.error(`Failed to close the conversation: ${error}`);
      onError?.();
    }
  });
};
